import { Box } from '@mui/material';
import { RouteBreadcrumb } from './RouteBreadcrumb';
import { SubBar } from './SubBar';
import { LastUpdated } from '@components/design-system';

interface BreadcrumbSubBarProps {
    children?: React.ReactNode;
    /** Optional last updated timestamp */
    lastUpdated?: Date | string | null;
}

export const BreadcrumbSubBar = ({ children, lastUpdated }: BreadcrumbSubBarProps) => {
    return (
        <SubBar>
            <Box
                sx={{
                    display: 'flex',
                    flex: 1,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                }}>
                {/* Left side: Breadcrumbs */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <RouteBreadcrumb />
                    {children}
                </Box>

                {/* Right side: Last updated */}
                {lastUpdated && <LastUpdated date={lastUpdated} />}
            </Box>
        </SubBar>
    );
};
